/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { HostTokenFromJSON, HostTokenDetailToJSON, LoginDetailToJSON, ParticipantVerifyInputToJSON, SetPasswordFromJSON, SetPasswordDetailToJSON, SpeakerTokenFromJSON, SpeakerTokenDetailToJSON, TelephonyPinFromJSON, TelephonyPinDetailToJSON, TelephonyPinVerifyFromJSON, TokenFromJSON, } from '../models/index';
/**
 *
 */
export class HostAuthApi extends runtime.BaseAPI {
    /**
     * Reset Host Password
     * Reset Host Password
     */
    hostHostIdPasswordResetPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['hostId'] == null) {
                throw new runtime.RequiredError('hostId', 'Required parameter "hostId" was null or undefined when calling hostHostIdPasswordResetPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/host/{HostId}/password/reset`.replace(`{${"HostId"}}`, encodeURIComponent(String(requestParameters['hostId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Reset Host Password
     * Reset Host Password
     */
    hostHostIdPasswordResetPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hostHostIdPasswordResetPutRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Update Host Password
     * Update Host Password
     */
    hostHostIdPasswordUpdatePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['hostId'] == null) {
                throw new runtime.RequiredError('hostId', 'Required parameter "hostId" was null or undefined when calling hostHostIdPasswordUpdatePut().');
            }
            if (requestParameters['setPasswordDetail'] == null) {
                throw new runtime.RequiredError('setPasswordDetail', 'Required parameter "setPasswordDetail" was null or undefined when calling hostHostIdPasswordUpdatePut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/host/{HostId}/password/update`.replace(`{${"HostId"}}`, encodeURIComponent(String(requestParameters['hostId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: SetPasswordDetailToJSON(requestParameters['setPasswordDetail']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SetPasswordFromJSON(jsonValue));
        });
    }
    /**
     * Update Host Password
     * Update Host Password
     */
    hostHostIdPasswordUpdatePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.hostHostIdPasswordUpdatePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Host Token
     * Host Token
     */
    hostTokenPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['hostTokenDetail'] == null) {
                throw new runtime.RequiredError('hostTokenDetail', 'Required parameter "hostTokenDetail" was null or undefined when calling hostTokenPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/host/token`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: HostTokenDetailToJSON(requestParameters['hostTokenDetail']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => HostTokenFromJSON(jsonValue));
        });
    }
    /**
     * Host Token
     * Host Token
     */
    hostTokenPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.hostTokenPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Telephony Pin
     * Telephony Pin
     */
    pinPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['telephonyPinDetail'] == null) {
                throw new runtime.RequiredError('telephonyPinDetail', 'Required parameter "telephonyPinDetail" was null or undefined when calling pinPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/pin`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: TelephonyPinDetailToJSON(requestParameters['telephonyPinDetail']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TelephonyPinFromJSON(jsonValue));
        });
    }
    /**
     * Telephony Pin
     * Telephony Pin
     */
    pinPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.pinPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Verify Telephony Pin
     * Verify Telephony Pin
     */
    pinVerifyPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['participantVerifyInput'] == null) {
                throw new runtime.RequiredError('participantVerifyInput', 'Required parameter "participantVerifyInput" was null or undefined when calling pinVerifyPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/pin/verify`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ParticipantVerifyInputToJSON(requestParameters['participantVerifyInput']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TelephonyPinVerifyFromJSON(jsonValue));
        });
    }
    /**
     * Verify Telephony Pin
     * Verify Telephony Pin
     */
    pinVerifyPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.pinVerifyPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Speaker Token
     * Speaker Token
     */
    speakerTokenPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['speakerTokenDetail'] == null) {
                throw new runtime.RequiredError('speakerTokenDetail', 'Required parameter "speakerTokenDetail" was null or undefined when calling speakerTokenPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/speaker/token`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SpeakerTokenDetailToJSON(requestParameters['speakerTokenDetail']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SpeakerTokenFromJSON(jsonValue));
        });
    }
    /**
     * Speaker Token
     * Speaker Token
     */
    speakerTokenPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.speakerTokenPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Authenticate Host
     * Authenticate Host
     */
    tokenAccountSidPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['accountSid'] == null) {
                throw new runtime.RequiredError('accountSid', 'Required parameter "accountSid" was null or undefined when calling tokenAccountSidPost().');
            }
            if (requestParameters['loginDetail'] == null) {
                throw new runtime.RequiredError('loginDetail', 'Required parameter "loginDetail" was null or undefined when calling tokenAccountSidPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/token/{AccountSid}`.replace(`{${"AccountSid"}}`, encodeURIComponent(String(requestParameters['accountSid']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LoginDetailToJSON(requestParameters['loginDetail']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
        });
    }
    /**
     * Authenticate Host
     * Authenticate Host
     */
    tokenAccountSidPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.tokenAccountSidPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
